export function TableListItem({ item, onSelect, selected }) {
  return (
    <div className="w-full mx-auto flex flex-row justify-between items-start mb-3 relative">
      {!item.paid || !(item.payment ==="PENDING") || !item.checkedOut ? (
        <input
          type="checkbox"
          id="item-checkbox"
          checked={selected === item.id}
          onChange={() => {
            onSelect(item.id);
          }}
          className="opacity-0 absolute w-6 h-6 rounded"
        />
      ) : (
        <></>
      )}
      <div
        className={
          item.paid || item.payment ==="PENDING" || item.checkedOut
            ? "border rounded-md border-black w-6 h-6 flex flex-shrink-0 justify-center items-center mr-5 bg-neutral-300"
            : "border rounded-md border-black w-6 h-6 flex flex-shrink-0 justify-center items-center mr-5 "
        }
      >
        <svg
          width="19"
          height="13"
          viewBox="0 0 19 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="hidden"
        >
          <path
            d="M6.41503 13H6.31522C5.58405 12.9677 4.89746 12.6574 4.41024 12.1388L0.373469 8.00527H0.373173C-0.011309 7.48949 -0.105217 6.82738 0.121871 6.23342C0.348959 5.63915 0.868105 5.18844 1.51189 5.02669C2.15535 4.86467 2.84165 5.01239 3.34899 5.42194L6.47858 8.62541L15.4868 0.60829C15.871 0.220049 16.4073 0 16.9684 0C17.5294 0.000280298 18.0654 0.220605 18.4496 0.608846C18.8335 0.997087 19.0314 1.51906 18.9959 2.05052C18.9605 2.58198 18.6953 3.0762 18.2627 3.41563L8.28381 12.2939C7.77884 12.7472 7.11031 12.9997 6.41511 13L6.41503 13Z"
            fill="#1D1817"
          />
        </svg>
      </div>

      <span className={
        item.paid || item.payment ==="PENDING" || item.checkedOut
          ? "line-through text-normal grow text-black font-light mb-2"
          : "text-normal grow text-black font-light mb-2"}>
        {item.name}
      </span>


      <span className={item.paid || item.payment ==="PENDING" || item.checkedOut ? "text-orange line-through" : "text-black"}>
        € {(item.amount).toFixed(2)}
      </span>
    </div>
  );
}
